import _ from 'lodashParts'
import DefaultPropsCollector from '../defaultPropsCollectors'
import DefaultDocumentServicesStylesManager from '../defaultDocumentServicesStylesManager'
import {normalizeCssFontFamily} from '../../utils/fontUtils'

const defaultFontsObj = {
    fonts: {},
    languages: []
}

function getDefaultPropsCollectorMethods() {
    const methods = Object.getOwnPropertyNames(Object.getPrototypeOf(new DefaultPropsCollector()))

    return _.pull(methods, 'constructor')
}

const propsCollectorMethods = getDefaultPropsCollectorMethods()

function mergePropsCollectorsAndBindMethods(...propsCollectors) {
    const mergedPropsCollector = {}

    _.forEach(propsCollectorMethods, method => {
        _.forEach(propsCollectors, collector => {
            if (collector[method]) {
                mergedPropsCollector[method] = (...args) => collector[method](...args)
            }
        })
    })

    return mergedPropsCollector
}

function normalizeFonts(propsCollector) {
    const fonts = propsCollector.getFonts()
    const res = _.cloneDeep(defaultFontsObj)

    _.forEach(fonts, function (lang) {
        res.languages.push(lang.lang)

        _.flow(
            x => _.reject(x, {premissions: 'legacy'}),
            x => _.forEach(x, font => {
                res.fonts[normalizeCssFontFamily(font.cssFontFamily)] = _.assign({}, font, {lang: lang.lang})
            })
        )(lang.fonts)
    })

    return res
}

function buildPropsCollectorCalculatedMethods(propsCollector) {
    //TODO - we didn't finish this... need to review and add code for the thing to actually work as intended
    let normalizedFonts = _.cloneDeep(defaultFontsObj)

    let cachedThemes = {}

    propsCollector.getNormalizedFonts = getExtendedObj => {
        if (_.isEqual(normalizedFonts, defaultFontsObj)) {
            normalizedFonts = normalizeFonts(propsCollector)
        }

        return getExtendedObj ? normalizedFonts : normalizedFonts.fonts
    }

    propsCollector.getCachedThemes = () => {
        if (_.isEmpty(cachedThemes)) {
            cachedThemes = propsCollector.getThemes()
        }

        return cachedThemes
    }
}

function buildPropsCollector(documentServicesApi, ...propsCollectors) {
    let _defaultPropsCollector = new DefaultPropsCollector()

    if (documentServicesApi) {
        _defaultPropsCollector = mergePropsCollectorsAndBindMethods(_defaultPropsCollector, new DefaultDocumentServicesStylesManager(documentServicesApi))
    }

    const propsCollector = mergePropsCollectorsAndBindMethods(_defaultPropsCollector, ...propsCollectors)

    buildPropsCollectorCalculatedMethods(propsCollector)

    return propsCollector
}

module.exports = {
    mergePropsCollectorsAndBindMethods,
    buildPropsCollector,
    buildPropsCollectorCalculatedMethods
}



// WEBPACK FOOTER //
// ./src/propsCollector/utils/propsCollectorUtils.js